import styled from 'styled-components';
import { Grid, Button } from '@simplywallst/ui-core';

export const CloseButton = styled(Button)`
  margin-right: -${({ theme }) => theme.x2spacePx}px;
`;

export const Header = styled(Grid)`
  padding-left: ${({ theme }) => theme.x2spacePx}px;
  padding-right: ${({ theme }) => theme.x2spacePx}px;
`;
